import { Menu as ArkMenu } from '@ark-ui/react/menu';
import { ReactNode } from 'react';

interface MenuProps {
  children: ReactNode;
}

export function Menu({ children }: MenuProps) {
  return <ArkMenu.Root>{children}</ArkMenu.Root>;
}

interface MenuTriggerProps {
  children: ReactNode;
  asChild?: boolean;
}

export function MenuTrigger({ children, asChild }: MenuTriggerProps) {
  return <ArkMenu.Trigger asChild={asChild}>{children}</ArkMenu.Trigger>;
}

export function MenuPositioner({ children }: MenuProps) {
  return <ArkMenu.Positioner>{children}</ArkMenu.Positioner>;
}

interface MenuContentProps {
  children: ReactNode;
  className?: string;
}

export function MenuContent({ children, className = '' }: MenuContentProps) {
  return (
    <ArkMenu.Content
      className={`bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50 min-w-[180px] ${className}`}
    >
      {children}
    </ArkMenu.Content>
  );
}

export function MenuSeparator({ className = '' }: { className?: string }) {
  return <ArkMenu.Separator className={`h-px bg-gray-200 my-1 ${className}`} />;
}

interface MenuItemLinkProps {
  children: ReactNode;
  onClick?: () => void;
}

export function MenuItem({ children, onClick }: MenuItemLinkProps) {
  return (
    <ArkMenu.Item 
      value={crypto.randomUUID()}
      onClick={onClick}
      className="px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 focus:bg-gray-100 outline-none flex items-center gap-2"
    >
      {children}
    </ArkMenu.Item>
  );
}
